module.exports = __webpack_public_path__ + "media/images/lb/670-dbad977954b0f27f7ab259d2cda00971.svg";